import React from 'react'
import { Info } from 'lucide-react'
import ReactMarkdown from 'react-markdown'
import { formatAssistantMessage, markdownComponents } from './markdownConfig'

function BotErrorMessage({ isErrorMessage, errorMessage }) {
    if (!isErrorMessage) return null

    return (
        <div className="w-full mt-4 animate-fadeIn">
            <div
                className="
                p-5 rounded-2xl border border-blue-100
                bg-gradient-to-br from-blue-50 to-blue-100/40
                shadow-sm hover:shadow-md
                transition-all duration-300
                relative
                "
            >
                {/* Light Info Icon */}
                <div className="absolute -top-3 -left-3 bg-white rounded-full p-1.5 shadow-sm border border-blue-100">
                    <Info size={18} className="text-blue-500 opacity-80" />
                </div>

                {/* Message */}
                <div className="text-blue-900 text-[15px] leading-relaxed select-text selection:bg-blue-500 selection:text-white">
                    <ReactMarkdown components={markdownComponents}>
                        {formatAssistantMessage(errorMessage)}
                    </ReactMarkdown>
                </div>
            </div>
        </div>
    )
}

export default BotErrorMessage;
